import '../../assets/components/EnvironmentBanner/EnvironmentBanner.css';//#region lib/components/EnvironmentBanner/EnvironmentBanner.module.css
var e = "_banner_1el3y_1", t = "_label_1el3y_8", n = "_toggle_1el3y_13", r = "_details_1el3y_24", i = "_message_1el3y_28", a = "_link_1el3y_33", o = "_desktopLabel_1el3y_62", s = "_caret_1el3y_71", c = "_expanded_1el3y_82", l = {
	banner: e,
	label: t,
	toggle: n,
	details: r,
	message: i,
	link: a,
	desktopLabel: o,
	caret: s,
	expanded: c
};
//#endregion
export { e as banner, s as caret, l as default, o as desktopLabel, r as details, c as expanded, t as label, a as link, i as message, n as toggle };
